import Spinner from '../common/Spinner';

const CustomSpinner = ({className}: {className?: string}) => {
  return (
    <Spinner className={`mt-52 size-10 self-center w-full ${className}`} />
  );
};

export default CustomSpinner;
